"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCustomerOrderItemHandler = updateCustomerOrderItemHandler;
var UpdateCustomerOrderItemFailed = _interopRequireWildcard(require("@ori-events/update-customer-order-item-failed"));
var _types = require("../types");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
async function updateCustomerOrderItemHandler({
  detail: {
    endConsumerOrderId,
    itemCode,
    placement,
    requestedQuantity
  }
}) {
  const fetchUrl = `${_types.RequestUrl.UpdateCustomerOrderItem}` + `?endConsumerOrderId=${endConsumerOrderId}` + `&itemCode=${itemCode}` + `&requestedQuantity=${requestedQuantity}`;
  const response = await fetch(fetchUrl, (0, _utils.getHttpRequestSettings)({
    placement
  }));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if (UpdateCustomerOrderItemFailed.isUpdateCustomerOrderItemErrorResponse(data)) {
    const errorEvent = new CustomEvent(UpdateCustomerOrderItemFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}
